import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-delete-section',
  templateUrl: './delete.component.html',
  styleUrls: ['./delete.component.scss'],
})
export class DeleteSectionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
